// extracted by mini-css-extract-plugin
export default {"hover":"socialMedia_hover__HoYbb","socialLink":"socialMedia_socialLink__4lTj+","bounce":"socialMedia_bounce__R3EQb"};